import React from 'react';
import Icon from 'components/AppIcon';

export default function BudgetStatusBar({ budgetData }) {
  const { totalBudget, totalSpent, category, categoryBudget, categorySpent } = budgetData;
  const overallPercent = Math.min(100, Math.round((totalSpent / totalBudget) * 100));
  const catPercent = Math.min(100, Math.round((categorySpent / categoryBudget) * 100));

  const getColor = (pct) => {
    if (pct >= 90) return 'text-red-400';
    if (pct >= 70) return 'text-amber-400';
    return 'text-emerald-400';
  };

  const getBarColor = (pct) => {
    if (pct >= 90) return 'bg-red-500';
    if (pct >= 70) return 'bg-amber-500';
    return 'bg-emerald-500';
  };

  return (
    <div
      className="absolute top-0 left-0 right-0 z-10 px-4 py-3"
      style={{ background: 'linear-gradient(to bottom, rgba(2,6,23,0.9) 0%, transparent 100%)' }}
    >
      <div className="flex items-center gap-4">
        {/* Monthly budget */}
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-center mb-1">
            <span className="text-xs text-slate-400 font-caption flex items-center gap-1">
              <Icon name="Wallet" size={12} color="#94A3B8" />
              Monthly
            </span>
            <span className={`font-data text-xs font-semibold ${getColor(overallPercent)}`}>
              ${(totalBudget - totalSpent)?.toFixed(0)} left
            </span>
          </div>
          <div className="h-1.5 bg-slate-700 rounded-full overflow-hidden">
            <div className={`h-full rounded-full transition-all ${getBarColor(overallPercent)}`} style={{ width: `${overallPercent}%` }} />
          </div>
        </div>

        <div className="w-px h-8 bg-slate-700" />

        {/* Category budget */}
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-center mb-1">
            <span className="text-xs text-slate-400 font-caption flex items-center gap-1">
              <Icon name="Tag" size={12} color="#94A3B8" />
              {category}
            </span>
            <span className={`font-data text-xs font-semibold ${getColor(catPercent)}`}>
              ${(categoryBudget - categorySpent)?.toFixed(0)} left
            </span>
          </div>
          <div className="h-1.5 bg-slate-700 rounded-full overflow-hidden">
            <div className={`h-full rounded-full transition-all ${getBarColor(catPercent)}`} style={{ width: `${catPercent}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
}